module.exports = __webpack_public_path__ + "static/segmentation@2x.112a8cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/segmentation@2x.png
// module id = 679
// module chunks = 193162123475590